export const formatDateString = (dateString, options) => {
  if (!dateString) return "N/A";
  const date = new Date(dateString.replace(/-/g, "/").replace(/T.+/, ""));
  const month = date.toLocaleString("en-us", { month: "short" });
  const year = date.getFullYear();
  const day = date.getDate();

  if (options?.includeYear) {
    return `${month} ${day}, ${year}`;
  } else {
    return `${month} ${day}`;
  }
};
